import { Card, Row } from "antd";
import { DataRow } from "./DataRow";
import { useCallback, useMemo } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Footer } from "../Footer";
import { useCompleteThirdStep } from "../../hooks/useCompleteThirdStep";
import { ErrorContainer } from "../SecondStep/ErrorContainer";
import { TokenTimer } from "./TokenTimer";
import { getFormattedCurrency } from "../../../../lib/currencyFormatter";
import { transformToFloat } from "../../../../lib/transformToFloat";

type ThirdStepProps = {
  request: any;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};

export const ThirdStep = ({ request, setStep }: ThirdStepProps) => {
  const amount: string = useMemo(
    () => getFormattedCurrency(transformToFloat(request.amount) ?? 0),
    [request],
  );

  const accountData: string = useMemo(
    () =>
      `#${request.contractNumber}${request.propertyAddress ? " - " + request.propertyAddress : ""}`,
    [request],
  );

  const { isLoading, onSubmit, error } = useCompleteThirdStep(request, setStep);

  const onBack = useCallback(() => setStep((prev) => prev - 1), [setStep]);

  return (
    <Card className="step">
      <Row className="justify-space-between">
        <p className="mt-0 mb-4 text w-500">Summary</p>
        {request.newMethod && <TokenTimer time={2} setStep={setStep} />}
      </Row>

      <Row className="d-block">
        <DataRow label="Amount" value={amount} bold />
        {request.comments && (
          <DataRow label="Comment" value={request.comments} />
        )}
        <DataRow label="Account" value={accountData} />
        {request.selectedMethodInfo && (
          <DataRow
            label="Bank"
            value={request.selectedMethodInfo.displayName}
          />
        )}
      </Row>
      <Row className="w-100 align-start desc-container mb-10 mt-6">
        <InfoCircleOutlined className="mr-2 text-md title" />
        <p className="my-0 text-md title desc">
          This payment <span className="text-md w-500">cannot be reversed</span>{" "}
          once submitted. Your bank account will be debited{" "}
          <span className="text-md w-500">within 3 business days</span> and
          you'll receive an email receipt.
        </p>
      </Row>
      {error && <ErrorContainer title={error} />}
      <Footer
        submitLabel="Submit Payment"
        onBack={onBack}
        isSaving={isLoading}
        onNext={onSubmit}
      />
    </Card>
  );
};
